import { atom, selector, selectorFamily } from 'recoil';

import type { VisiblePalette } from './types';

/**
 * Recoil global state storing the currently opened palette.
 */
export const openedPaletteAtom = atom<VisiblePalette | null>({
    key: 'palette-opened',
    dangerouslyAllowMutability: true,
    default: null,
});

export const isPaletteOpenedSelector = selector({
    key: 'palette-isOpened',
    dangerouslyAllowMutability: true,
    get: ({ get }) => get(openedPaletteAtom) !== null,
});

export const paletteOpenedByIdSelector = selectorFamily({
    key: 'palette-openedById',
    dangerouslyAllowMutability: true,
    get:
        (id: string) =>
        ({ get }) => {
            const state = get(openedPaletteAtom);
            return Boolean(state && state.id === id);
        },
});
